<template>
  <div class="container">
    <center>
      <loader-component :show="loading"></loader-component>
    </center>
    <div class="row">
      <div class="col-md-12" v-if="error">
        <p>{{ error }}</p>
      </div>
    </div>
    <template v-if="!loading && !error">
      <div class="row">
        <div class="col-md-12">
          <h3>Endereço</h3>
        </div>
        <div class="col-md-2">
          <label class="text text-primary">CEP</label>
          <span class="text">{{ endereco.cep }}</span>
        </div>
        <div class="col-md-4">
          <label class="text text-primary">Logradouro</label>
          <span class="text">{{ endereco.logradouro }}</span>
        </div>
        <div class="col-md-2">
          <label class="text text-primary">Número</label>
          <span class="text">{{ endereco.numLogradouro }}</span>
        </div>
        <div class="col-md-2">
          <label class="text text-primary">Bairro</label>
          <span class="text">{{ endereco.bairro }}</span>
        </div>
        <div class="col-md-2">
          <label class="text text-primary">Município</label>
          <span class="text">{{
            `${nomeMunicipio} (${endereco.codMunicipio})`
          }}</span>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-md-2">
          <label class="text text-primary">Cód. Tipo Logradouro</label>
          <span class="text">{{ endereco.codTipoLogradouro }}</span>
        </div>
        <div class="col-md-2">
          <label class="text text-primary">UF</label>
          <span class="text">{{ endereco.uf }}</span>
        </div>
      </div>
      <div class="row mt-2" v-if="atividadesEconomica !== null">
        <div class="col-md-12">
          <h3>Atividades econômicas</h3>
        </div>
        <div class="col-md-4">
          <label class="text text-primary">Objeto social</label>
          <span class="text">{{ atividadesEconomica.objetoSocial }}</span>
        </div>
        <div class="col-md-4">
          <label class="text text-primary">CNAE Fiscal</label>
          <span class="text">{{ atividadesEconomica.cnaeFiscal.codigo }}</span>
        </div>
        <div class="col-md-4">
          <label class="text text-primary">CNAEs Secundários</label>
          <template v-if="atividadesEconomica.cnaesSecundarias">
            <template
              v-if="
                Array.isArray(
                  atividadesEconomica.cnaesSecundarias.cnaeSecundaria
                )
              "
            >
              <ul>
                <li
                  v-for="(cnaeSecundario, index) of atividadesEconomica
                    .cnaesSecundarias.cnaeSecundaria"
                  :key="index"
                >
                  <span class="text">{{ cnaeSecundario.codigo }}</span>
                </li>
              </ul>
            </template>
            <template v-else>
              <span class="text">{{
                atividadesEconomica.cnaesSecundarias.cnaeSecundaria.codigo
              }}</span>
            </template>
          </template>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h3>Sócios</h3>
        </div>
        <div class="col-md-3" v-for="(socio, index) in socios" :key="index">
          <div class="card">
            <div class="card-header">Sócio {{ index + 1 }}</div>

            <div class="card-body">
              <p>
                <b>Nome:</b>
                {{ socio.nome }}
              </p>
              <p>
                <b>Tipo do sócio:</b>
                {{ socio.identificadorTipoSocio }}
              </p>
              <p>
                <b>Capital social:</b>
                {{ socio.capitalSocialSocio }}
              </p>
              <p>
                <b>Código de qualificação:</b>
                {{ socio.codQualificacaoSocio }}
              </p>
              <p>
                <b>É o proprietário?</b>
                {{ socio.isProprietario ? "SIM" : "NÃO" }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["cnpj"],
  data() {
    return {
      error: null,
      socios: [],
      atividadesEconomica: null,
      endereco: {},
      loading: true,
      nomeMunicipio: ""
    };
  },
  methods: {
    getData() {
      axios
        .get(`/sie/iframe/jucec-api?cnpj=${this.cnpj}`)
        .then(response => response.data)
        .then(data => {
          const {
            registrosRedesim: {
              registroRedesim: {
                dadosRedesim: {
                  atividadesEconomica,
                  endereco,
                  responsavelPeranteCnpj,
                  socios: { socio }
                }
              }
            }
          } = data;
          this.endereco = endereco;

          if (endereco.cep) {
            $.getJSON(`https://viacep.com.br/ws/${endereco.cep}/json`, data => {
              if (data.erro === undefined) {
                this.nomeMunicipio = data.localidade + '/' + data.uf;
              }
            });
          }

          this.atividadesEconomica = atividadesEconomica;
          if (Array.isArray(socio)) {
            socio.map(item => {
              item.isProprietario =
                item.cnpjCpfSocio === responsavelPeranteCnpj.cpfResponsavel;
            });
            this.socios = socio;
          } else {
            socio.isProprietario = true;
            this.socios = [socio];
          }
        })
        .catch(e => {
          console.log(e);
          this.error = "Não foi possível carregar os dados da junta";
        })
        .then(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.container {
  background: #fff;
}
</style>
